import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'antd';
import { withTranslation } from 'react-i18next';

import FIELD_TYPES from '../../../configs/fieldTypes';
import Icon from '../UI/Icon';
import ButtonTransparent from '../UI/ButtonTransparent';
import FieldConfigMenu from './FieldConfigMenu';
import { connect } from '../../StateProvider';

import styles from './fieldConfig.less';

class FieldConfig extends PureComponent {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    catalogId: PropTypes.string.isRequired,
    viewMode: PropTypes.string.isRequired,
    showHiddenFields: PropTypes.bool,
    sortable: PropTypes.bool,
    viewId: PropTypes.string, // optional - not always available (e.g. in History, Calendar)
  };

  state = {
    visible: false,
    discardedFiltersKeys: [],
  };

  handleVisibleChange = (flag) => this.setState({ visible: flag });

  getFieldsCount() {
    const { fields, showHiddenFields, visibleFields, defaultVisible } = this.props;
    if (!fields) return 0;

    const effectiveDefaultVisible = defaultVisible === undefined ? true : defaultVisible;

    return fields
      .filter(
        (col) =>
          col.get('type') !== FIELD_TYPES.GROUP &&
          col.get('type') !== FIELD_TYPES.BUTTON &&
          col.get('type') !== FIELD_TYPES.IFRAME,
      )
      .filter((col) => showHiddenFields || !col.get('hidden'))
      .filter((col) => !col.get('hiddenByRights'))
      .filter((col) => {
        if (!visibleFields) return effectiveDefaultVisible;
        const visible = visibleFields.getIn([col.get('id'), 'visible']);
        return visible === undefined ? effectiveDefaultVisible : visible;
      }).size;
  }

  render() {
    const fieldsCount = this.getFieldsCount();

    return (
      <Dropdown
        dropdownRender={() => (
          <FieldConfigMenu
            fields={this.props.fields}
            catalogId={this.props.catalogId}
            viewMode={this.props.viewMode}
            showHiddenFields={this.props.showHiddenFields}
            viewId={this.props.viewId}
            sortable={this.props.sortable}
            defaultVisible={this.props.defaultVisible}
            className={styles.fieldConfig}
          />
        )}
        trigger={['click']}
        placement="bottomLeft"
        onOpenChange={this.handleVisibleChange}
        open={this.state.visible}
        overlayClassName={styles.fieldConfigDropdown}
      >
        <ButtonTransparent
          className={this.props.className || styles.buttonFieldConfig}
          title={this.props.t('record.filter.name')}
        >
          <Icon className={styles.icon} type="icon text-36" />
          <span>{this.props.t('views.fields')}</span>
          {fieldsCount > 0 && <b className={styles.count}>{fieldsCount}</b>}
        </ButtonTransparent>
      </Dropdown>
    );
  }
}

export default withTranslation()(
  connect(
    FieldConfig,
    {
      viewSettings: ['viewSettings', 'catalogs'],
    },
    (props, { viewSettings }) => {
      const { catalogId, viewId, viewMode } = props;
      const settings = viewId && viewMode && viewSettings && viewSettings.getIn([catalogId, 'views', viewId, viewMode]);
      const visibleFields = settings ? settings.get('fields') : undefined;

      return {
        ...props,
        visibleFields,
      };
    },
  ),
);
